import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import fetchWP from './utils/fetchWP';
import Loader from './utils/loader'

export default class Listing extends Component {
    render() {
        return (
            <div class="awdp_listing">
                <div>
                    <Rows />
                </div>
            </div>
        );
    }
}
 
class Rows extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            items: []
        }
        this.fetchWP = new fetchWP({
            restURL: window.awdp_object.root,
            restNonce: window.awdp_object.api_nonce,
        });
    }
    componentDidMount() {
       document.body.classList.remove('wdpa-details'); 
       this.getRules();
    } 
    getRules = () => {
        this.fetchWP.get('productlist')
            .then( 
                (json) => this.setState({
                    loading: false,
                    items: json,
                }),
                (err) => console.log('error', err)
            );
    };
    render() {

        var out = '';
        if(this.state.items != null){
            out = this.state.items.map((item, i) => (
                <Row key={i} item={item} />
            ));
        }

        if(this.state.loading) 
            return (<Loader />);
        else 
            return (<table class="wp-list-table widefat fixed striped"><thead><tr><th scope="col" id="title" class="manage-column awdp-column column-primary large"><span>Title</span></th><th scope="col" id="date" class="manage-column awdp-column small"><span>Date</span></th></tr></thead><tbody>{out}</tbody></table>);
    }

}

function Row(props) {
    return ( 
        <tr><td><Link title="Edit" to={'/list/' + props.item.list_id}>{props.item.list_name != '' ? props.item.list_name : 'Product List' }</Link></td><td>{props.item.list_date}</td></tr>
    );
}